import React, { memo } from "react";

import { SkeletonList } from "@hl/base-components/lib/Skeleton";
import { Group, Stack, Skeleton } from "@mantine/core";

const MarketplaceHeaderSkeleton = () => {
  return (
    <Group>
      <SkeletonList
        count={6}
        skeleton={
          <Stack spacing="sm">
            <Skeleton height={26} width={50} />
            <Skeleton height={16} width={100} />
          </Stack>
        }
      />
    </Group>
  );
};

export default memo(MarketplaceHeaderSkeleton);
